module.exports = __webpack_public_path__ + "static/media/whichThinnerCost.8da88920.mp3";